var _effectorFileName = "/src/page-content/individual-lessons/ui.tsx";
import { useRouter } from 'next/router';
import { WebPageJsonLd } from 'next-seo';
import { HelpAchieveGoals } from '@/page-content/individual-lessons/components/help-achieve-goals';
import { MainIndividualLessons } from '@/page-content/individual-lessons/components/main-individual-lessons';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { SERVICES_LIST } from '@/widgets/layouts/main/constants/services-list';
import { Pricing } from '@/widgets/layouts/main/pricing/pricing';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { PlusesIndividualLessons } from './components/pluses-individual-lessons';
export const IndividualLessonsPage = () => {
  const router = useRouter();
  return <>
      <PageSeo title="Индивидуальные занятия" description={`Индивидуальные занятия – кратчайший путь к достижению новых высот. ${APP_TITLE} – деловой английский для работы.`} />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} name={`${APP_TITLE} - Индивидуальные занятия`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} description={`Индивидуальные занятия – кратчайший путь к достижению новых высот. ${APP_TITLE} – деловой английский для работы.`} about={['английский', 'онлайн', 'индивидуальные занятия']} />

      <MainIndividualLessons />

      <HelpAchieveGoals />

      <PlusesIndividualLessons />

      <Pricing servicesList={SERVICES_LIST} />

      <Reviews />

      <CallToAction withForm />
    </>;
};
IndividualLessonsPage.Layout = MainLayout;